module.exports = __webpack_public_path__ + "img/inet-logo.9bc737ac.png";